module.exports = __webpack_public_path__ + "static/media/37.6c0c8e79.jpg";